export default __webpack_public_path__ + "static/media/new-project.3479cf67.svg";